/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Card } from "antd";
import { Collapse, Form, Flex, Row, Col, Space } from "antd";
import { Input, Button, Table, message, DatePicker, Typography } from "antd";
import {
  SearchOutlined,
  ClearOutlined,
  FileAddOutlined,
} from "@ant-design/icons";
import { accessColumn } from "./model";
import useAccessPageState from "../../hooks/useAccessPageState";

import dayjs from "dayjs";
import ProductSpecificationService from "../../service/ProductSpecification.service";

import useColumnSettings from "../../hooks/useColumnSettings";
const pspService = ProductSpecificationService();
const mngConfig = {
  title: "",
  textOk: null,
  textCancel: null,
  action: "create",
  code: null,
};

const RangePicker = DatePicker.RangePicker;
const ProductSpecificationAccess = () => {
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const [accessData, setAccessData] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const CollapseItemSearch = (
    <>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item label="PSP Code" name="psp_code">
            <Input placeholder="Enter ProductSpecification Code." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item label="PSP Date" name="psp_date">
            <RangePicker
              placeholder={["เริ่มวันที่", "ถึงวันที่"]}
              style={{ width: "100%", height: 40 }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item label="Product Name" name="spname">
            <Input placeholder="Enter Product Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item label="Product Code" name="product_code">
            <Input placeholder="Enter Product Code." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item label="Sample Code" name="spcode">
            <Input placeholder="Enter Sample Code." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item label="Customer Name" name="cusname">
            <Input placeholder="Enter Customer Name." />
          </Form.Item>
        </Col>

        {/* <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                <Form.Item label='สร้างโดย' name='created_by'>
                    <Input placeholder='Enter First Name or Last Name.' />
                </Form.Item>
            </Col> */}
      </Row>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={8} md={12} lg={12} xl={12}>
          <Flex justify="flex-end" gap={8}>
            <Button
              type="primary"
              size="small"
              className="bn-action"
              icon={<SearchOutlined />}
              onClick={() => handleSearch()}
            >
              ค้นหา
            </Button>
            <Button
              type="primary"
              size="small"
              className="bn-action"
              danger
              icon={<ClearOutlined />}
              onClick={() => handleClear()}
            >
              ล้าง
            </Button>
          </Flex>
        </Col>
      </Row>
    </>
  );

  const FormSearch = (
    <Collapse
      size="small"
      onChange={(e) => {
        setActiveSearch(e);
      }}
      activeKey={activeSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined />
              <span> ค้นหา</span>
            </>
          ),
          children: <>{CollapseItemSearch}</>,
          showArrow: false,
        },
      ]}
      // bordered={false}
    />
  );

  const handleSearch = (load = false, forcedValues = null, paginationOverride = null) => {
    const runSearch = (v) => {
      saveState(v, paginationOverride ?? tablePagination);
      const data = { ...v };
      if (!!data?.psp_date) {
        const arr = data?.psp_date.map((m) => dayjs(m).format("YYYY-MM-DD"));
        const [psp_date_form, psp_date_to] = arr;
        //data.created_date = arr
        Object.assign(data, { psp_date_form, psp_date_to });
      }
      setTimeout(
        () =>
          pspService
            .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
            .then((res) => {
              const { data } = res.data;

              setAccessData(data);
            })
            .catch((err) => {
              console.log(err);
              message.error("Request error!");
            }),
        80
      );
    };

    if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
      runSearch(forcedValues);
      return;
    }

    form.validateFields().then((v) => {
      runSearch(v);
    });
  };

  const handleClear = () => {
    clearState();
    form.resetFields();

    const nextPagination = restoreDefaultPagination();

    handleSearch(false, {}, nextPagination);
  };
  // console.log(form);
  const hangleAdd = () => {
    navigate("manage/create", {
      state: { config: { ...mngConfig, title: "สร้างPSP", action: "create" } },
    });
  };
  const handleDelete = (data) => {
    // startLoading();
    pspService
      .deleted(data?.psp_code)
      .then((_) => {
        const tmp = accessData.filter((d) => d.psp_code !== data?.psp_code);
        message.success("ยกเลิก " + data?.psp_code + " สำเร็จ!");
        setAccessData([...tmp]);
      })
      .catch((err) => {
        console.log(err);
        message.error("Request error!");
      });
  };

  const handleView = (data) => {
    navigate("view", {
      state: { config: { ...mngConfig, title: "View", code: data?.psp_code } },
    });
  };

  const handlePrint = (recode) => {
    // const targetUrl = `/psp-print/${recode?.psp_code}/${recode?.version}`;
    // const newWindow = window.open(targetUrl, "_blank", "noopener,noreferrer");

    const newWindow = window.open("", "_blank");
    newWindow.location.href = `/psp-print/${recode?.psp_code}/${recode?.version}`;
  };

  const allColumns = accessColumn({ handleDelete, handleView, handlePrint });
  /* คอลัมน์ที่แสดง ผู้ใช้เลือกเองได้ ระบบจำไว้ใน cookie ของเครื่องนี้ */
  const { columns: column, settingsButton } = useColumnSettings(
    "product_specification_mypageaccess_cols",
    allColumns
  );

  const getData = (data) => {
    handleSearch();
  };

  const init = async () => {
    getData({});
  };

  useEffect(() => {
    const restored = restoreState();

    handleSearch(false, restored?.searchValues ?? null, restored?.tablePagination);

    return async () => {
      //console.clear();
    };
  }, []);
  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            Product Specification
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {settingsButton}
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<FileAddOutlined style={{ fontSize: ".9rem" }} />}
            onClick={() => {
              hangleAdd();
            }}
          >
            Create PSP
          </Button>
        </Flex>
      </Col>
    </Flex>
  );
  return (
    <div className="productspecification-access" id="area">
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", position: "relative" }}
      >
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          onValuesChange={() => {
            handleSearch(true);
          }}
        >
          {FormSearch}
        </Form>
        <Card>
          <Row gutter={[8, 8]} className="m-0">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                title={() => TitleTable}
                size="small"
                rowKey="psp_code"
                columns={column}
                dataSource={accessData}
                scroll={{ x: "max-content" }}
                pagination={tablePagination}
                onChange={handleTableChange}
              />
            </Col>
          </Row>
        </Card>
      </Space>
    </div>
  );
};

export default ProductSpecificationAccess;
